import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ShotsApiService from "@/core/services/api.service.shots";

export default {
  name: "Shots",
  data() {
    return {
      shots: [],
      totalShots: 0,
      loading: false,
      deleting: false,
      deleteDialog: false,
      selectedShot: null,

      // Video preview
      videoPreviewDialog: false,
      selectedVideoId: null,

      // Service ready
      serviceReady: false,

      filters: {
        userId: null,
        userEmail: "",
        username: ""
      },
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
      },
      headers: [
        {
          text: "Shot ID",
          value: "shotId",
          sortable: false,
          width: "6%"
        },
        {
          text: "Video",
          value: "video",
          sortable: false,
          width: "10%"
        },
        {
          text: "Video ID",
          value: "videoId",
          sortable: false,
          width: "12%"
        },
        {
          text: "User",
          value: "user",
          sortable: false,
          width: "20%"
        },
        {
          text: "Creator Profile ID",
          value: "creatorProfileId",
          sortable: false,
          width: "10%"
        },
        {
          text: "Shop",
          value: "shopName",
          sortable: false,
          width: "15%"
        },
        {
          text: "Status",
          value: "deleted",
          sortable: false,
          width: "10%"
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          align: "center",
          width: "10%"
        }
      ]
    };
  },

  mounted() {
    ShotsApiService.init().then(() => {
      this.serviceReady = true;
      this.searchShots();
    });
  },

  watch: {
    pagination: {
      handler() {
        if (this.serviceReady) {
          this.searchShots();
        }
      },
      deep: true
    }
  },

  async created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dashboard", route: "dashboard" },
      { title: "Shots" }
    ]);
  },

  methods: {
    async searchShots() {
      if (!this.serviceReady) return;

      this.loading = true;
      try {
        const params = {
          page: this.pagination.page - 1,
          size: this.pagination.itemsPerPage
        };

        if (this.filters.userId) {
          params.userId = this.filters.userId;
        }
        if (this.filters.userEmail && this.filters.userEmail.trim()) {
          params.userEmail = this.filters.userEmail.trim();
        }
        if (this.filters.username && this.filters.username.trim()) {
          params.username = this.filters.username.trim();
        }

        const response = await ShotsApiService.search(params);

        if (response.data) {
          this.shots = response.data.content || [];
          this.totalShots = response.data.totalElements || 0;
        }
      } catch (error) {
        console.error("Error searching shots:", error);
        this.$bvToast.toast("Failed to load shots. Please try again.", {
          title: "Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 3000
        });
        this.shots = [];
        this.totalShots = 0;
      } finally {
        this.loading = false;
      }
    },
    clearFilters() {
      this.filters = {
        userId: null,
        userEmail: "",
        username: ""
      };
      this.pagination.page = 1;
      this.searchShots();
    },
    openDeleteDialog(shot) {
      this.selectedShot = shot;
      this.deleteDialog = true;
    },
    closeDeleteDialog() {
      this.deleteDialog = false;
      this.selectedShot = null;
    },
    async confirmDelete() {
      if (!this.selectedShot) return;

      this.deleting = true;
      try {
        const response = await ShotsApiService.delete(this.selectedShot.videoId);

        this.$bvToast.toast("Shot deleted successfully", {
          title: "Success",
          variant: "success",
          solid: true,
          autoHideDelay: 3000
        });
        this.closeDeleteDialog();
        this.searchShots();
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$bvToast.toast("Access denied. Admin rights required.", {
            title: "Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 3000
          });
        } else {
          this.$bvToast.toast("Failed to delete shot. Please try again.", {
            title: "Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 3000
          });
        }
      } finally {
        this.deleting = false;
      }
    },
    openVideoPreview(videoId) {
      this.selectedVideoId = videoId;
      this.videoPreviewDialog = true;
    },
    closeVideoPreview() {
      this.videoPreviewDialog = false;
      this.selectedVideoId = null;
    },
    removeVideoFromPreview() {
      const shot = this.shots.find(s => s.videoId === this.selectedVideoId);
      if (shot) {
        this.closeVideoPreview();
        this.openDeleteDialog(shot);
      }
    },
    getVideoThumbnailUrl(videoId) {
      if (!videoId) return null;
      return `https://res.cloudinary.com/ooblee/video/upload/so_0,w_150,h_150,c_fill/${videoId}.jpg`;
    },
    getVideoUrl(videoId) {
      if (!videoId) return null;
      return `https://res.cloudinary.com/ooblee/video/upload/${videoId}`;
    }
  }
};
